"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcurrentStatisticsTitle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../common");
const TitleContainer = styled_components_1.default.div `
    display: flex;
    gap: 23px;
    align-items: center;

    .refresh-rate {
        display: flex;
        gap: 12px;
        align-items: center;
    }

    span {
        font-size: 16px;
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 600;
        color: #101010;
    }
`;
const REFRESH_RATE_DROPDOWN_LIST = [
    { id: '0', title: 'common.searchCondition' },
    { id: '5', title: '5초' },
    { id: '15', title: '15초' },
    { id: '30', title: '30초' },
    { id: '60', title: '1분' },
];
exports.ConcurrentStatisticsTitle = react_1.default.memo(({ refreshRate, setRefreshRate, refresh }) => {
    const [value, setValue] = react_1.default.useState(() => {
        const initial = REFRESH_RATE_DROPDOWN_LIST.find(item => item.id === String(refreshRate));
        return initial || REFRESH_RATE_DROPDOWN_LIST[0];
    });
    const handlerUpdateDrop = (item) => {
        setValue(item);
        setRefreshRate(Number(item.id));
    };
    return (react_1.default.createElement(TitleContainer, null,
        react_1.default.createElement(common_1.Button, { className: "btn_tur sm", onClick: refresh, text: "common.refresh", styles: {
                buttonWrap: { width: '96px' }
            } }),
        react_1.default.createElement("div", { className: "refresh-rate" },
            react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: value, list: REFRESH_RATE_DROPDOWN_LIST, styles: {
                    dropWrap: {
                        width: "100px",
                    },
                }, setDropValue: handlerUpdateDrop }),
            react_1.default.createElement("span", null, "\uB9C8\uB2E4 \uAC31\uC2E0"))));
});
